import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mp_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export const COMPANY = {
  name: "MP Autobedrijf",
  street: "Johannes Huddeweg 14",
  postal: "6827 CB Arnhem",
  city: "Arnhem Noord",
  email: "info@mpautobedrijf.com",
  phone: "085 060 5028",
  whatsapp: "31850605028",
  website: "mpautobedrijf.com",
  rating: 4.9,
  reviews_count: 44,
  hoursKeys: [
    { key: "hours.mo", time: "08:30 – 17:30" },
    { key: "hours.tu", time: "08:30 – 17:30" },
    { key: "hours.we", time: "08:30 – 17:30" },
    { key: "hours.th", time: "08:30 – 17:30" },
    { key: "hours.fr", time: "08:30 – 17:30" },
    { key: "hours.sa", timeKey: "hours.opAfspraak" },
    { key: "hours.su", timeKey: "hours.opAfspraak" },
  ],
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_d18f6833-d0fb-4eb1-8e13-5e5acd0eae4f/artifacts/itc1q8k2_58B4A2FB-2C38-4220-8170-4B53EED4B172.png";

export function carImageUrl(src) {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  if (src.startsWith("/api/")) return `${BACKEND_URL}${src}`;
  return src;
}

export function formatEUR(n) {
  if (n === undefined || n === null) return "";
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(n);
}

export function formatKM(n) {
  if (!n && n !== 0) return "—";
  return new Intl.NumberFormat("nl-NL").format(n) + " km";
}
